import { Typography } from "@mui/material";
import React, { ReactNode } from "react";

const DescriptionText = ({ children }: { children: ReactNode }) => {
  return (
    <Typography
      sx={{
        fontWeight: "400",
        paddingX: 10,
        fontSize: {
          xs: "16px",
          sm: "25px",
        },
        textAlign: "center",
        lineHeight: {
          xs: "17px",
          sm: "27px",
        },
      }}
      mb={1}
    >
      {children}
    </Typography>
  );
};

export default DescriptionText;
